export default __webpack_public_path__ + "static/Shiraz-831bc099f0b85221a85c8adb1d7401d1.jpg";